<div class="delegated-to-me-tab">
    <div *ngIf="ismyDelegationsDataAvailable && !showLoader" id="delegated-to-me-tab-panel-list">
      <app-delegation-panel-list 
      [showLoader] = "showPanelLoader"
      [myDelegationsData]="myDelegationsData"
      [isDelegateFromDisplayed]="true"
      [isDelegateToDisplayed]="false"
      [isInActiveSelected]="isActiveDelegatesInDelegatedToMe"
      (showInactiveDelegates)="showInactiveDelegates()">
    </app-delegation-panel-list>
    </div>
</div>